
import { PropType, defineComponent } from 'vue';

import BaseFormField from '@/shared/components/form/BaseFormField.vue';
import FormCheckbox from '@/shared/components/form/FormCheckbox.vue';
import FormFieldDropdown from '@/shared/components/form/FormFieldDropdown.vue';
import FormFieldInput from '@/shared/components/form/FormFieldInput.vue';
import FormFieldSet from '@/shared/components/form/FormFieldSet.vue';
import { DropdownItem, DropdownItemsPerCategory } from '@/shared/components/form/formFieldDropdownTypes';

type AdditionalPropertyInput = {
  key: string;
  label: string;
  value: number | null;
  various: boolean;
};

type AdditionalPropertyGroup = {
  key: string;
  headline: string;
  properties: AdditionalPropertyInput[];
};

export default defineComponent({
  name: 'FourthStep',
  components: {
    BaseFormField,
    FormCheckbox,
    FormFieldDropdown,
    FormFieldInput,
    FormFieldSet,
  },
  props: {
    showDropdown: {
      type: Boolean,
      required: true,
    },
    showNoValidBbchRangeWarning: {
      type: Boolean,
      default: false,
    },
    selectedBbchCode: {
      type: Number as PropType<number | null>,
      default: null,
    },
    selectedDropdownItem: {
      type: Object as PropType<DropdownItem>,
      required: true,
    },
    dropdownItems: {
      type: Array as PropType<DropdownItemsPerCategory[]>,
      required: true,
    },
    dropdownItemsLoading: {
      type: Boolean,
      default: false,
    },
    bbchDescription: {
      type: String as PropType<string | null>,
      default: null,
    },
    additionalPropertyGroups: {
      type: Array as PropType<AdditionalPropertyGroup[]>,
      default: () => [],
    },
    showInspectionConducted: {
      type: Boolean,
      default: false,
    },
    inspectionConducted: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateDropdown(dropdownItem: DropdownItem): void {
      if (!dropdownItem.id) {
        this.$emit('updateBbchCode', null);
        return;
      }

      const parsed = Number.parseInt(String(dropdownItem.id), 10);
      if (Number.isNaN(parsed) || parsed < 0 || parsed > 99) {
        this.$emit('updateBbchCode', null);
        return;
      }

      this.$emit('updateBbchCode', parsed);
    },
    updateManualBbchCode(value: number | string | null): void {
      if (value === null || value === '') {
        this.$emit('updateBbchCode', null);
        return;
      }

      const parsed = typeof value === 'number' ? value : Number.parseInt(value, 10);
      if (Number.isNaN(parsed)) {
        this.$emit('updateBbchCode', null);
        return;
      }
      if (parsed < 0 || parsed > 99) {
        return;
      }

      this.$emit('updateBbchCode', Math.floor(parsed));
    },
    updateAdditionalProperty(propertyKey: string, value: number | string | null): void {
      if (value === null || value === '') {
        this.$emit('updateAdditionalProperty', { key: propertyKey, value: null });
        return;
      }

      const parsed = typeof value === 'number' ? value : Number.parseFloat(value);
      if (Number.isNaN(parsed)) {
        this.$emit('updateAdditionalProperty', { key: propertyKey, value: null });
        return;
      }

      this.$emit('updateAdditionalProperty', { key: propertyKey, value: parsed });
    },
    updateInspectionConducted(value: boolean): void {
      this.$emit('updateInspectionConducted', !!value);
    },
  },
});
